module.exports = __webpack_public_path__ + "pnskfsquadron/img/en-slider-5.jpg?5e72a271";